import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as drawer } from './drawer';
import { reducer as filtersData } from './filtersData';
import { reducer as trendsData } from './trendsData';
import { reducer as thresholdData } from './threshold';
import { reducer as sharing } from './sharing';
import { reducer as dashboard } from './dashboard';
import { reducer as tempDashboard } from './tempDashboard';

export default combineReducers({
  base,
  drawer,
  filtersData,
  trendsData,
  thresholdData,
  sharing,
  dashboard,
  tempDashboard,
});
